module.exports = __webpack_public_path__ + "static/media/arrow-down.1b15bd6f.svg";